import React from "react";
import { E } from "./Emoji";
type TrustRowProps = {
  items: string[];
};
export function TrustRow({
  items
}: TrustRowProps) {
  return <ul className="flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-sm font-semibold text-white/85" data-id="element-282" data-mp="22zb97a8w8xvk">
      {items.map(item => <li key={item} className="whitespace-nowrap" data-id="element-283" data-mp="2cpefud8xuacd">
          <E data-id="element-284" data-mp="2cpwgdm2mvaq3">{item}</E>
        </li>)}
    </ul>;
}